import {useCallback} from 'react';
import {useSetItemFlags} from '@/api/hooks';
import {getApiErrorMessage} from '@/api/client';
import {type Item} from '@/api/items';
import {type FlagColor} from '@/api/flags';
import {showToast} from '@/lib/toast';

// ItemsGrid's onSetFlag for a page whose items come from useItems / useJobItems: optimistic through
// the react-query cache, with a toast when the write fails and the flag snaps back. Stable across
// renders (react-query's mutate is), so it doesn't re-render every memoised card it is handed to.
export function useSetItemFlag() {
  const {mutate} = useSetItemFlags();
  return useCallback(
    (item: Item, color: FlagColor | null) => {
      mutate(
        {itemIds: [item.id], color},
        {
          onError(error) {
            showToast(
              getApiErrorMessage(error, color ? 'Failed to flag item.' : 'Failed to clear flag.'),
              'error'
            );
          }
        }
      );
    },
    [mutate]
  );
}
